import withCountryInfo from '../../../hocs/withCountryInfo';

import GlobalSearchContainer from './container';
import GlobalSearchComponent from './component';

export { GlobalSearchComponent, GlobalSearchContainer };

export default withCountryInfo(GlobalSearchContainer);
